import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { durationTime } from "../../../../general/functions/datetimeFunction";
import useDataSession from "../../customeHooks/useDataSession";
const moment = require("moment");

export default function DurationSession() {
  const [text, setText] = useState("");
  const { dataSession } = useDataSession();

  useEffect(() => {
    let timeStart =
      dataSession.sessionInfo?.openedOn != null
        ? dataSession.sessionInfo?.openedOn
        : moment().unix();
    console.log(
      "dataSession.sessionInfo?.openedOn",
      dataSession.sessionInfo?.openedOn,
      dataSession
    );
    const interval = setInterval(() => {
      setText(durationTime(timeStart));
    }, 1000);
    return () => clearInterval(interval);
  }, [dataSession.sessionInfo?.openedOn]);

  return <>{text}</>;
}
